import { ElMessage } from 'element-plus';

type WebAppToastType = 'success' | 'error' | 'info' | 'warning';

const TOAST_CLASS = 'web-app-toast';
const DEFAULT_DURATIONS: Record<WebAppToastType, number> = {
  success: 4000,
  error: 6000,
  info: 4000,
  warning: 5000,
};

export function showWebAppToast(
  message: string,
  type: WebAppToastType = 'info',
  duration?: number,
) {
  ElMessage({
    message,
    type,
    duration: duration ?? DEFAULT_DURATIONS[type],
    customClass: TOAST_CLASS,
    showClose: true,
    grouping: true,
    offset: 20,
  });
}

export const webAppToast = {
  success: (message: string, duration?: number) => showWebAppToast(message, 'success', duration),
  error: (message: string, duration?: number) => showWebAppToast(message, 'error', duration),
  info: (message: string, duration?: number) => showWebAppToast(message, 'info', duration),
  warning: (message: string, duration?: number) => showWebAppToast(message, 'warning', duration),
};

export default webAppToast;
